import { useEffect } from "react";

/**
 * SkipToContent — WCAG 2.1 SC 2.4.1 (Bypass Blocks).
 *
 * Renders a visually hidden link that appears on focus, letting keyboard
 * and screen-reader users jump straight to the main content and skip the
 * repetitive header/nav on every page.
 *
 * Usage: place at the very top of <Layout>. Requires the <main> element to
 * have `id="main-content"` and `tabIndex={-1}` so it can be programmatically
 * focused.
 */
export default function SkipToContent() {
  // Move focus into main-content when the link is clicked. This bypasses
  // the browser's inconsistent :target behavior on programmatic anchors.
  useEffect(() => {
    const handler = (e) => {
      if (e.target?.matches?.('[data-skip-to="main"]')) {
        e.preventDefault();
        const el = document.getElementById("main-content");
        if (el) {
          el.focus({ preventScroll: false });
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  return (
    <a
      href="#main-content"
      data-skip-to="main"
      className="skip-to-content"
      data-testid="skip-to-content"
    >
      Saltar al contenido principal
    </a>
  );
}
